// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"a9b3d85d","445":"a9b3d85d","525":"2d35ba4b","647":"3c2b1ed1","782":"43f5406f"}[chunkId] + ".chunk.css";
};